export default __webpack_public_path__ + "static/media/cow_grayscale.5591a8b7.svg";